"use client";
import MediaGallery from "@/ui/MediaGallery";
import Intro from "@/ui/Intro";
import Link from "next/link";

const getImageUrl = (media) => {
    if (typeof media === 'string') return media;
    if (!media) return null;

    const mediaAttr = media.attributes || media;
    return mediaAttr.url ||
        mediaAttr.formats?.medium?.url ||
        mediaAttr.formats?.large?.url ||
        mediaAttr.formats?.small?.url ||
        mediaAttr.formats?.thumbnail?.url ||
        null;
};

const extractText = (richText) => {
    if (!richText) return "";
    if (typeof richText === "string") return richText.trim();
    if (Array.isArray(richText)) {
        return richText.map(extractText).join(" ").trim();
    }
    if (richText.children && Array.isArray(richText.children)) {
        return richText.children
            .map(child => {
                if (child.type === "text" && child.text) return child.text;
                return extractText(child);
            })
            .join("")
            .trim();
    }
    return "";
};

const InfrastructureGallery = ({ schoolSections }) => {
    const infraData = schoolSections?.infrasturcturegallery?.data?.[0] ||
        schoolSections?.infrasturcturegallery?.[0];

    if (!infraData) return null;
    console.log("Infrastructure Gallery Data:", infraData);
    const infraBlock = infraData.attributes || infraData;
    const imagesWithDetailsRaw = infraBlock?.images_with_details?.data ||
        infraBlock?.images_with_details || [];

    if (!imagesWithDetailsRaw?.length) return null;
    const infraItems = imagesWithDetailsRaw
        .map((itemData, index) => {
            const item = itemData.attributes || itemData;
            let media = item.media ||
                (item.Media?.data?.[0]?.attributes || item.Media?.data?.[0]) ||
                (item.Media?.[0]?.attributes || item.Media?.[0]);

            if (!media) return null;

            const isVideo = media.mime?.startsWith("video/");
            let imgUrl = getImageUrl(media);

            if (isVideo && item.thumbnailimage) {
                imgUrl = getImageUrl(item.thumbnailimage);
            }

            if (!imgUrl) return null;
            return {
                src: imgUrl,
                alt: extractText(item.Heading) || `Image ${index + 1}`,
                label: extractText(item.Heading),
                isVideo,
                videoUrl: isVideo ? getImageUrl(media) : undefined,
                heading: extractText(item.Heading),
                subheading: extractText(item.SubHeading),
            };
        })
        .filter(Boolean);

    if (infraItems.length === 0) {
        return (
            <div className="page-container py-12 text-center text-gray-500">
                Gallery content is being prepared.
            </div>
        );
    }

    return (
        <div className="bg-[#081E2D] mt-14 mb-14">
            <div className="page-container pt-5 pb-20">
                <Intro
                    className="text-white mb-12"
                    title={extractText(infraBlock.title) || "Infrastructure Gallery"}
                    description={extractText(infraBlock.subheading) || "Experience our world-class facilities."}
                />
                <MediaGallery items={infraItems} />

                <section className="bg-[#FFA500] py-8 mt-12 px-6 md:px-10 ">
                    <div className=" mx-auto flex flex-col lg:flex-row items-center justify-between gap-6">
                        <p className="text-xl md:text-2xl lg:text-3xl max-w-5xl font-semibold leading-relaxed text-center lg:text-left"
                            style={{ fontFamily: 'saans-bold' }}
                        >{extractText(infraBlock.CTA_Text)}
                        </p>
                        <Link
                            href="/application"
                            className="w-full lg:w-auto flex justify-center lg:justify-start items-center gap-3 bg-[#081E2D] text-white px-8 py-4  text-lg font-semibold transition-all duration-300 hover:bg-[#0a2a40]"
                        >
                            Apply Now ↗
                        </Link>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default InfrastructureGallery;
